<template>
	<div ref="self" class="l-row--t64 l-row--t128l module rail" :class="{ 'rail--device': data.target.itemType == 'device', 'rail--no-desc': !data.target.body && !data.target.bodyKo && methods.checkRoute() }">
		<div class="g-row rail__item-wrap" :class="data.target.swap == 1 && 's--h-reverse'">
			<div class="g-col--5 g-col--4s g-mr--1s i--desc-wrap">
				<div class="rail__desc-wrap">
					<div class="t-b--18 t-b--16s rail__desc i--body-en" v-html="data.target.body"></div>
					<div class="l-mdl--16 t-b--18 t-b--16s rail__desc i--body-kr" v-html="data.target.bodyKo"></div>
				</div>
			</div>
			<div v-if="data.target.itemType == 'picture'" class="g-col--9 g-col--8l g-col--5s rail__item-col">
				<div v-for="(item, index) in data.target.items" :key="index" class="l-mdl--64 c-pic rail__item" :class="`rail__item--${index}`">
					<Picture v-show="methods.checkDisplay(item.src)" class="i--pic-1" :coverSrc="item.coverSrc" :parallax="item.parallax == 0 ? false : true" :src="item.src" :from="item.from" :embedType="item.embedType" :ratio="item.ratio" />
					<div class="c-pic__desc i--desc-1">
						<div class="t-h--13 t-h--11s">
							<span class="t--fak c-pic__desc--info" v-html="item.caption"></span>
						</div>
					</div>
				</div>
			</div>
			<div v-if="data.target.itemType == 'device'" class="g-col--7 g-col--5l g-col--5s g-mr--1 g-mr--2l g-mr--0s rail__item-col">
				<Device
					v-for="(item, index) in data.target.items" :key="index"
					class="l-mdl--64 l-mdl--128l rail__item c-dvc--rail-solo"
					:class="`rail__item--${index}`"
					:noSrcBoxDisplay="methods.checkDisplay(item.src)" :itemIndex="1" :notch="data.target.notch == 1 ? true : false" :target="item"
				/>
				<!-- <div v-for="(item, index) in data.target.items" :key="index" class="l-mdl--64 l-mdl--128l  c-dvc c-dvc--ipx rail__item" :class="`rail__item--${index}`">
					<div class="c-dvc__img-wrap" v-show="methods.checkDisplay(item.src)">
						<div class="c-dvc__img-box i--pic-1">
							<Picture :coverSrc="item.coverSrc" :parallax="item.parallax == 0 ? false : true" class="c-dvc__img" :src="item.src" :from="item.from" :embedType="item.embedType" :ratio="item.ratio" />
						</div>
						<img class="c-dvc__mask" :src="require(`@/assets/common/device-mask/iphone12${ data.target.notch == 1 ? '-notch' : ''}.svg`)" alt="">
					</div>
					<div class="c-dvc__desc i--desc-1">
						<div class="t-h--13 t-h--11s">
							<span class="t--fak c-dvc__desc--info" v-html="item.caption"></span>
						</div>
					</div>
				</div> -->
			</div>
			<div v-if="data.target.itemType == 'device2'" class="g-col--9 g-col--5s rail__item-col">
				<div v-for="(item, index) in data.target.items" :key="index" class="l-mdl--64 l-mdl--128l rail__item twin-dvc" :class="`rail__item--${index}`">
					<div class="g-row--fit">
						<div class="g-col twin-dvc__item i--item-1">
							<Device class="c-dvc--twin" :noSrcBoxDisplay="methods.checkDisplay(item.device[0].src)" :itemIndex="1" :notch="data.target.notch == 1 ? true : false" :target="item.device[0]" />
						</div>
						<div class="g-col twin-dvc__item i--item-2">
							<Device class="c-dvc--twin" :noSrcBoxDisplay="methods.checkDisplay(item.device[1].src)" :itemIndex="2" :notch="data.target.notch == 1 ? true : false" :target="item.device[1]" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as $ from "fxdom";
import * as _ from "fxjs";
import { gsap } from "gsap/all";
import { computed, onMounted, onBeforeUnmount, ref, reactive, watch, useStore } from "@/helper/vue.js";
import { getPinnedScroll, stPos } from "@/helper/gadget.js";
import Picture from "@/parts/picture/PictureView.vue";
import Device from "@/parts/work-view/_Device.vue";
import { useRoute } from 'vue-router';

export default {
  props: ["idx", "bindRoot", "type"],
	components: {
		Picture,
		Device
	},
  setup(props) {
    const { state, get, commit } = useStore();
		const self = ref();
		const route = useRoute();
		const data = reactive({
			target: computed(() => get["from"](`${props.bindRoot}.modules.${props.idx}`)),
		});

		const methods = {
			checkDisplay: (src) => {
				return route.name == "project" && src == "" ? false : true
			},
			checkRoute: () => {
				return route.name == "project" ? true : false
			}
		}

		let CB_RESIZE = null;
		let railTl
    const CB_LANDED = () => {
			const descWrap = $.qs(".rail__desc-wrap", self.value);
			const descParent = $.qs(".i--desc-wrap", self.value);
			const dvcIpx = $.qs(".c-dvc--ipx", self.value);

			let endPos;
			let startPos;

			CB_RESIZE = () => {
				const endLine = descWrap.clientHeight + 48;
				const vH = window.innerHeight;
				startPos = 48/vH;
				if (data.target.itemType == 'picture') {
					endPos = endLine/vH;
				} else {
					const style = dvcIpx.currentStyle || window.getComputedStyle(dvcIpx);
					const paddingBtm = Number(style.paddingBottom.slice(0, -2));
					endPos = (endLine + paddingBtm)/vH;
				}
			}

      CB_RESIZE();

			window.addEventListener("resize", CB_RESIZE);

      railTl = gsap.timeline({
        scrollTrigger: {
          trigger: $.qs(".rail__item-col", self.value),
          start: e => stPos(e, 0, startPos),
          end: e => stPos(e, 1, endPos),
          scrub: true,
          // markers: true,
          onEnter() {
          },
          onUpdate({ start, progress }) {
            // (PC)pin start
            !state.isMobileAgent && gsap.set(descWrap, {y: Math.round(getPinnedScroll(start))});
          },
          onLeave({ start, end }) {
            // (PC)pin end
            !state.isMobileAgent && gsap.set(descWrap, { y: end - start });
          },
          onRefresh({ start, end, direction }) {
            if (direction == 1) {
							!state.isMobileAgent && gsap.set(descWrap, { y: end - start });
            } else if (direction == -1 ) {
							!state.isMobileAgent && gsap.set(descWrap, { y: 0 });
            }
          }
        }
      });

			if (state.isMobileAgent) {
				$.setCss({
					position: 'sticky',
					top: '48px',
				}, descWrap)
				if (data.target.itemType !== 'picture') {
					$.setCss({
						paddingBottom: '32em',
					}, descParent)
				}
			}
    }

		onMounted(() => {
			window.addEventListener("landed", CB_LANDED);
		});

		onBeforeUnmount(() => {
			window.removeEventListener("landed", CB_LANDED);
			window.removeEventListener("resize", CB_RESIZE);
		});

    return {
			self,
			data,
			methods
    };
  },
};
</script>

<style scoped lang="scss">
.rail {
	&__desc {
		.w600__ &:first-child {
			margin-top: 0;
		}
	}
	&__item {
		.w600__ &:first-child {
			margin-top: 0;
		}
		.__w600 & {
			margin-top: 64em;
		}
		&-wrap {
			justify-content: space-between;
			.__w600 & {
				justify-content: center;
			}
		}
	}
	&__item-col {

	}
	.c-dvc {
		.__w600 & {
			padding-bottom: 16em;
		}
	}
}

.twin-dvc {
	&__item {
		&:nth-child(even) {
			margin-top: 128em;
			.__w600 & {
				margin-top: 64em;
			}
		}
		.w1600__ & {
			margin-left: 64em;
			margin-right: 64em;
			.c-dvc {
				margin-left: 0;
				margin-right: 0;
			}
		}
	}
}

.w600__ .s--h-reverse {
	.g-mr--1 {
		margin-right: auto;
		margin-left: calc(var(--cw1) + 1.5 * var(--gutter));
	}
}

.rail--no-desc {
	.i--desc-wrap {
		.__w600 & {
			display: none;
		}
	}

	.rail__item {
		.__w600 & {
			&:first-child {
				margin-top: 0;
			}
		}
	}
}

</style>